module.exports = __webpack_public_path__ + "static/media/tipologia6.ac3c8875.png";